import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PathMeme from '../assets/path-meme.jpg';

const Home = () => {
  return (
    <>
      <Row className="justify-content-md-center">
        <Col md="auto">
          <figure>
            <img src={PathMeme} alt="Which Path?" />
            <figcaption>Wrong place</figcaption>
          </figure>        
        </Col>
      </Row>
    </>
  );
};

export default Home;
